export const countConversationsRatedUniqueCustomer = {
  analysisType: 'count_unique',
  eventCollection: 'message.rated',
  key: 'countConversationsRatedUniqueCustomer',
  targetProperty: 'conversation.customer.id',
}
